export const OVERVIEW_TABS = Object.freeze({
  overview: Object.freeze({
    key: 'overview',
    title: 'Overview',
    path: '/analytics/test-overview/overview',
    trackEvent: 'TEST_OVERVIEW_DEFAULT_TAB',
  }),
  tests: Object.freeze({
    key: 'tests',
    title: 'Tests',
    path: '/analytics/test-overview/tests',
    trackEvent: 'TEST_OVERVIEW_TESTS_TAB',
  }),
  errors: Object.freeze({
    key: 'errors',
    title: 'Errors',
    path: '/analytics/test-overview/errors',
    trackEvent: 'TEST_OVERVIEW_ERRORS_TAB',
  }),
});
